/* Keep published promotion copy truthful across cached HTML and open tabs. */
(() => {
  if (customElements.get('daelivo-campaign')) return;
  class DaelivoCampaign extends HTMLElement {
    connectedCallback() {
      this.onResume = () => this.refresh();
      document.addEventListener('visibilitychange', this.onResume);
      window.addEventListener('pageshow', this.onResume);
      this.refresh();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.onResume);
      window.removeEventListener('pageshow', this.onResume);
    }
    refresh() {
      clearTimeout(this.timer);
      const start = Date.parse(this.getAttribute('data-campaign-start'));
      const end = Date.parse(this.getAttribute('data-campaign-end'));
      const now = Date.now();
      const valid = Number.isFinite(start) && Number.isFinite(end) && end > start;
      const active = valid && now >= start && now < end;
      this.querySelectorAll('[data-campaign-active]').forEach(node => { node.hidden = !active; });
      this.querySelectorAll('[data-campaign-inactive]').forEach(node => { node.hidden = active; });
      const next = now < start ? start : end;
      if (valid && next > now) this.timer = setTimeout(() => this.refresh(), Math.min(next - now, 2147483647));
    }
  }
  customElements.define('daelivo-campaign', DaelivoCampaign);
})();
